export enum UserFlag {
  ShowPopupInfoMakeItemPublic = "showPopupInfoMakeItemPublic",
  ShowPopupInfoMakeItemPrivate = "showPopupInfoMakeItemPrivate",
}
